import React, { useCallback, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { semaphoreLocksActions } from '../../actions/semaphoreLocksActions';
import userApi from '../../api/UserApi';
import Button from '../common/Button';
import { BsChevronDoubleDown } from 'react-icons/bs';
import { BsExclamationOctagon } from 'react-icons/bs';
import GlobalModal from '../common/GlobalModal';
import { useState } from 'react';
import * as commonSelectors from '../common/selectors';
import * as semaphoreSelectors from './selectors';
import ModalEnum from '../../shared/enums/modalEnum';

const SemaphoreLocks = () => {
    const [semaphoreLocks, setSemaphoreLocks] = useState([]);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [hasRight, setHasRight] = useState(false);
    const [unlockConfirm, setUnlockConfirm] = useState(false);
    const [unlockAllConfirm, setUnlockAllConfirm] = useState(false);
    const [semaphoreToLock, setSemaphoreToLock] = useState(null);

    const isAuthorizedSelector = useSelector(commonSelectors.isAuthorized);
    const rightsSelector = useSelector(commonSelectors.userRights);
    const semaphoreLocksSelector = useSelector(semaphoreSelectors.semaphoreLocks);

    const dispatch = useDispatch();

    const refreshSemaphoreLocks = useCallback(() => {
        dispatch(
            semaphoreLocksActions.getSemaphoreLocks()
        );
    }, [dispatch]);

    useEffect(() => {
        if (hasRight === true) {
            refreshSemaphoreLocks();
        }
    }, [hasRight, refreshSemaphoreLocks]);

    useEffect(() => {
        const _hasRight = rightsSelector?.fullControl ?? false;
        const _isAuthorized = isAuthorizedSelector ?? false;

        if (_isAuthorized) {
            setIsAuthorized(_isAuthorized);
            setHasRight(_hasRight);

            if (_isAuthorized !== isAuthorized) {
                dispatch(
                    semaphoreLocksActions.getSemaphoreLocks()
                );
            }
        } else {
            userApi.login();
        }
    }, [isAuthorized, isAuthorizedSelector, rightsSelector, dispatch]);

    useEffect(() => {
        setSemaphoreLocks(semaphoreLocksSelector ?? []);
    }, [semaphoreLocksSelector]);

    const unlockSemaphore = semaphore => {
        dispatch(
            semaphoreLocksActions.unlockSemaphore(semaphore)
        );
    }

    const unlockAllSemaphores = () => {
        dispatch(
            semaphoreLocksActions.unlockAllSemaphores()
        );
    }

    const closeUnlockConfirm = () => {
        setUnlockConfirm(false);
    }

    const onUnlockSemaphore = () => {
        closeUnlockConfirm();
        if (semaphoreToLock !== null) {
            unlockSemaphore(semaphoreToLock);
        }
    }

    const closeUnlockAllConfirm = () => {
        setUnlockAllConfirm(false);
    }

    const onUnlockAllSemaphores = () => {
        closeUnlockAllConfirm();
        unlockAllSemaphores();
    }

    function renderSemaphoreLocks() {
        if (semaphoreLocks.length > 0) {
            return semaphoreLocks.map((lock, index) => {
                return (
                    <tr key={index}>
                        <td style={{ align: 'center', fontWeight: 'bold', color: 'green' }}>{lock.tenant} </td>
                        <td style={{ align: 'center', whiteSpace: 'nowrap', color: lock.semaphore.indexOf('DataConsistency') !== -1 ? 'orange' : 'violet' }}>{lock.semaphore} </td>
                        <td style={{ align: 'center', whiteSpace: 'nowrap', color: 'white' }}>{lock.info} </td>
                        <td style={{ width: '140px', margin: 0, padding: 0 }}>
                            <button
                                color="link"
                                size="sm"
                                style={{
                                    width: '100%',
                                    fontWeight: 'bold',
                                    color: '#FF6347',
                                    backgroundColor: 'rgba(255, 255, 255,.08)'
                                }}
                                onClick={() => {
                                    setUnlockConfirm(true);
                                    setSemaphoreToLock(lock.semaphore);
                                }}
                            >
                                Remove Lock
                            </button>
                        </td>
                    </tr>
                )
            });
        }
        else {
            return (
                <tr>
                    <td
                        colSpan='4'
                        style={{
                            align: 'center',
                            fontWeight: 'bold',
                            color: 'green'
                        }}
                    >
                        There are no semaphore locks at this moment
                    </td>
                </tr>
            );
        }
    }

    return (
        <div>
            {isAuthorized && semaphoreLocks !== undefined &&
                <div
                    className="semaphore card-body"
                    style={{ height: '890px' }}
                >
                    <div
                        className="button-items"
                        style={{ marginBottom: '10px' }}
                    >
                        <ul>
                            <li>
                                <Button
                                    onClick={() => refreshSemaphoreLocks()}
                                    text={"Refresh"}
                                    icon={<BsChevronDoubleDown />}
                                />
                            </li>
                            {semaphoreLocks.length > 0 &&
                                <li>
                                    <Button
                                        onClick={() => setUnlockConfirm(true)}
                                        text={"Unlock all"}
                                        icon={<BsExclamationOctagon />}
                                    />
                                </li>
                            }
                        </ul>
                    </div>
                    <div
                        style={{
                            overflowY: 'auto',
                            marginBottom: '1px solid black'
                        }}
                    >
                        <Table
                            id="log-table"
                            striped
                            bordered
                            hover
                            size="sm"
                        >
                            <thead>
                                <tr>
                                    <th style={{ width: '110px' }}>Tenant</th>
                                    <th style={{ width: '240px' }}>Semaphore</th>
                                    <th style={{ width: '260px' }}>Information</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: 12 }}>
                                {renderSemaphoreLocks()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            }
            <GlobalModal
                type={ModalEnum.Confirmation}
                isOpen={unlockConfirm}
                accept={onUnlockSemaphore}
                decline={closeUnlockConfirm}
                content={{
                    text: "<span>Are you sure unlock following semaphore?</span><br /><br /><b>" + semaphoreToLock + "</b>",
                    html: true,
                }}
            />
            <GlobalModal
                type={ModalEnum.Confirmation}
                isOpen={unlockAllConfirm}
                accept={onUnlockAllSemaphores}
                decline={closeUnlockAllConfirm}
                content={{ text: "Are you sure unlock all semaphores?" }}
            />
        </div>
    );
}


export default SemaphoreLocks;